/**
 * Created by admin on 2018/4/2.
 */
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Modal, Radio, Slider } from 'antd';
import classNames from 'classnames';
import { ROTATION_DURATIONS, ROTATION_MODE, PARTICIPANT_STATUS, CHINESE, ENGLISH } from '../utils/constants';
import MeetingModal from './MeetingModal';
import LayoutSetting from './LayoutSetting';
import RoomSelect from './RoomSelect';

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

class RotationSetting extends React.Component {
  static defaultProps = {
    visible: false,
    ongoing: false, //是否正处于轮询中，当处于轮询中时，无法编辑，只能结束轮询后才能编辑
  };

  constructor() {
    super();
    this.state = {
      mode: ROTATION_MODE.single,
      duration: ROTATION_DURATIONS[0],
      screenNum: 4,
      mainRoomLayout: 'speakerOnly',
      pollingParticipants: [],
      showLayoutSetting: false,
      showRoomSelect: false
    };
  }

  componentWillReceiveProps(nextProps) {
    const { visible } = nextProps;
    if (!visible) {
      this.setState({
        mode: ROTATION_MODE.single,
        duration: ROTATION_DURATIONS[0],
        screenNum: 4,
        mainRoomLayout: 'speakerOnly',
        pollingParticipants: [],
        showLayoutSetting: false,
        showRoomSelect: false
      });
    }
  }

  render() {
    const {
      onClose,
      ongoing,
      dispatch,
      participantList,
      intl
    } = this.props;
    const {
      mode,
      duration,
      screenNum,
      mainRoomLayout,
      pollingParticipants,
      showRoomSelect,
      showLayoutSetting
    } = this.state;

    const marks = {};
    for (let i = 4; i <= 9; i++) {
      marks[i] = i;
    }

    return (
      <div className={classNames('rotation-container', { ongoing: !!ongoing })}>
        {!ongoing && (
          <div className="content-wrap">
            <div className="row-wrap">
              <div className="prefix">
                <FormattedMessage id="mc_rotation_model" />
                <span>*</span>
              </div>
              <div className="handle">
                <RadioGroup
                  onChange={e => this.setState({ mode: e.target.value })}
                  value={mode}
                >
                  <RadioButton value={ROTATION_MODE.single}>
                    <FormattedMessage id="mc_rotation_single" />
                  </RadioButton>
                  <RadioButton value={ROTATION_MODE.multi}>
                    <FormattedMessage id="mc_rotation_multi" />
                  </RadioButton>
                </RadioGroup>
              </div>
            </div>
            <div className="row-wrap">
              <div className="prefix">
                <FormattedMessage id="mc_rotation_interval" />
                <span>*</span>
              </div>
              <div className="handle">
                <RadioGroup
                  onChange={e => this.setState({ duration: e.target.value })}
                  value={duration}
                >
                  {ROTATION_DURATIONS.map(itv => (
                    <RadioButton key={itv} value={itv}>
                      {itv}S
                    </RadioButton>
                  ))}
                </RadioGroup>
              </div>
            </div>
            <div className="row-wrap">
              <div className="prefix">
                <FormattedMessage id="mc_rotation_mainLayout" />
                <span>*</span>
              </div>
              <div className="handle handle-flex">
                {mainRoomLayout ? (
                  <FormattedMessage id={`mc_layout_${mainRoomLayout}`} />
                ) : (
                  <FormattedMessage id="mc_layout_current" />
                )}
                <span
                  className="select-btn"
                  onClick={() => this.setState({ showLayoutSetting: true })}
                >
                  <FormattedMessage id="mc_btn_select" />
                </span>
                {mainRoomLayout ? (
                  <span
                    className="select-btn"
                    onClick={() => this.setState({ mainRoomLayout: null })}
                  >
                    <FormattedMessage id="mc_btn_cancel" />
                  </span>
                ) : null}
              </div>
            </div>
            {mode === ROTATION_MODE.multi ? (
              <div className="row-wrap">
                <div className="prefix">
                  <FormattedMessage id="mc_rotation_nums" />
                  <span>*</span>
                </div>
                <div className="handle">
                  <Slider
                    min={4}
                    max={9}
                    marks={marks}
                    step={1}
                    onChange={val => this.setState({ screenNum: val })}
                    value={screenNum}
                  />
                </div>
              </div>
            ) : null}
            <div className="row-wrap">
              <div className="prefix">
                <FormattedMessage id="mc_rotation_rotas" />
                <span>*</span>
              </div>
              <div className="handle handle-flex">
                {this.getRotationRooms()}
                <span
                  className="select-btn"
                  onClick={() => this.setState({ showRoomSelect: true })}
                >
                  <FormattedMessage id="mc_btn_select" />
                </span>
              </div>
            </div>
          </div>
        )}
        <div className="operate">
          {ongoing ? (
            <div
              className="btn"
              onClick={() => {
                dispatch({ type: 'meetingControl/stopRotation' });
                onClose();
              }}
            >
              <FormattedMessage id="mc_btn_stop" />
            </div>
          ) : (
            <div
              className="btn"
              onClick={() => {
                dispatch({
                  type: 'meetingControl/startRotation',
                  setting: {
                    mode,
                    duration,
                    screenNum,
                    mainRoomLayout,
                    pollingParticipants
                  }
                });
                onClose();
              }}
            >
              <FormattedMessage id="mc_btn_ok" />
            </div>
          )}
          <div className="btn" onClick={onClose}>
            <FormattedMessage id="mc_btn_cancel" />
          </div>
        </div>
        <MeetingModal
          visible={showLayoutSetting}
          title={intl.formatMessage({ id: 'mc_rotation_mainLayout' })}
          onClose={() => {
            this.setState({ showLayoutSetting: false });
          }}
          width={600}
          content={
            <LayoutSetting
              defaultLayout={mainRoomLayout}
              onChange={layout => {
                this.setState({ mainRoomLayout: layout });
              }}
              onClose={() => {
                this.setState({ showLayoutSetting: false });
              }}
            />
          }
        />

        <MeetingModal
          visible={showRoomSelect}
          title={intl.formatMessage({ id: 'mc_label_room_select' })}
          onClose={() => this.setState({ showRoomSelect: false })}
          width={480}
          content={
            <RoomSelect
              participantList={participantList}
              defaultSelectedKeys={pollingParticipants}
              onChange={selectedKeys =>
                this.setState({ pollingParticipants: selectedKeys })
              }
              onClose={() => this.setState({ showRoomSelect: false })}
            />
          }
        />
      </div>
    );
  }

  getRotationRooms = () => {
    const { participantList, intl } = this.props;
    const { pollingParticipants } = this.state;
    const rooms = [];

    pollingParticipants.forEach(rid=>{
      const cp = participantList.find(p=>p.participantId==rid);
      if (cp.removed === 0 && cp.state === PARTICIPANT_STATUS.connected) {
        let roomName = intl.locale === ENGLISH ? cp.nameEn : cp.name;
        rooms.push(roomName)
      }
    })

    if (rooms.length === 0) {
      return intl.formatMessage({ id: 'mc_rotation_allParticipants' });
    } else {
      const dot = intl.formatMessage({ id: 'mc_rotation_dot' });
      if (rooms.length > 4) {
        return intl.formatMessage({
          id: 'mc_rotation_partiEnum',
          values: { enumStr: rooms.slice(0, 4).join(dot), num: rooms.length }
        });
      } else {
        return rooms.join(dot);
      }
    }
  };
}

export default injectIntl(RotationSetting);



// WEBPACK FOOTER //
// ./src/components/RotationSetting.js